import { createSlice } from '@reduxjs/toolkit';
import {
  CreateMacue,
  DeleteMacue,
  EditMacueDetail,
  GetAllMacue,
  GetAllMajorMacue,
  GetSingleMacueDetails,
  SearchForMacuesByName,
} from './macue_services_sync';

export const macueSlice = createSlice({
  name: 'macue',
  initialState: {
    macue_loader: false,
    allMacueLoader: true,
    macueDeleteLoader: false,
    macueEditLoader: false,
    mcuEditLoader: false,
    message: '',
    completeMacue: {},
    completeMajorMacue: [],
    macueDetails: {},
    completeMacueSearch: {},
    macue_page: 0,
    macue_limit: 10,
    editMacueId: '',
  },
  reducers: {
    clearState: (state) => {
      state.macue_loader = false;
      state.message = '';
      state.completeMacue = {};
      state.completeMajorMacue = [];
      state.allMacueLoader = true;
      state.macueDeleteLoader = false;
      state.macueEditLoader = false;
      state.mcuEditLoader = false;
      state.macueDetails = {};
      state.completeMacueSearch = {};
      state.editMacueId = '';

      return state;
    },

    updateMacueDetails: (state, action) => {
      state.macueDetails = action.payload;
    },

    updateCompleteMacue: (state, action) => {
      state.completeMacue = action.payload;
    },
    updateMacueId: (state, { payload }) => {
      state.editMacueId = payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(CreateMacue.pending, (state) => {
        state.macue_loader = true;
      })
      .addCase(CreateMacue.fulfilled, (state, { payload }) => {
        state.macue_loader = false;
        state.message = payload.message;
      })
      .addCase(CreateMacue.rejected, (state, { payload }) => {
        state.macue_loader = false;
        state.message = payload.message;
      })

      .addCase(GetAllMacue.pending, (state) => {
        state.macue_loader = true;
      })
      .addCase(GetAllMacue.fulfilled, (state, { payload }) => {
        state.macue_loader = false;
        state.message = payload.message;
        state.completeMacue = payload.data;
        state.macue_page = payload?.data?.page;
      })
      .addCase(GetAllMacue.rejected, (state, { payload }) => {
        state.macue_loader = false;
        state.message = payload.message;
      })
      .addCase(GetAllMajorMacue.pending, (state) => {
        state.macue_loader = true;
      })
      .addCase(GetAllMajorMacue.fulfilled, (state, { payload }) => {
        state.macue_loader = false;
        state.message = payload.message;
        state.completeMajorMacue = payload.data;
      })
      .addCase(GetAllMajorMacue.rejected, (state, { payload }) => {
        state.macue_loader = false;
        state.message = payload.message;
      })
      .addCase(DeleteMacue.pending, (state) => {
        state.macueDeleteLoader = true;
      })
      .addCase(DeleteMacue.fulfilled, (state, { payload }) => {
        const filterData = state.completeMacue?.docs?.filter(
          (item) => item._id !== payload?.data?._id
        );

        state.completeMacue = {
          ...state.completeMacue,
          docs: filterData,
        };

        state.macueDeleteLoader = false;
        state.message = payload.message;

        state.editMacueId = '';
      })
      .addCase(DeleteMacue.rejected, (state, { payload }) => {
        state.macueDeleteLoader = false;
        state.message = payload.message;
        state.editMacueId = '';
      })
      .addCase(GetSingleMacueDetails.pending, (state) => {
        state.macue_loader = true;
      })
      .addCase(GetSingleMacueDetails.fulfilled, (state, { payload }) => {
        state.macue_loader = false;
        state.message = payload.message;
        state.macueDetails = payload.data;
      })
      .addCase(GetSingleMacueDetails.rejected, (state, { payload }) => {
        state.macue_loader = false;
        state.message = payload.message;
      })
      .addCase(EditMacueDetail.pending, (state) => {
        state.mcuEditLoader = true;
      })
      .addCase(EditMacueDetail.fulfilled, (state, { payload }) => {
        state.mcuEditLoader = false;
        state.message = payload.message;
      })
      .addCase(EditMacueDetail.rejected, (state, { payload }) => {
        state.mcuEditLoader = false;
        state.message = payload.message;
      })

      .addCase(SearchForMacuesByName.pending, (state) => {
        state.macue_loader = true;
      })
      .addCase(SearchForMacuesByName.fulfilled, (state, { payload }) => {
        state.macue_loader = false;
        state.message = payload?.message;

        state.completeMacueSearch = payload?.data;
      })
      .addCase(SearchForMacuesByName.rejected, (state, { payload }) => {
        state.macue_loader = false;
        state.message = payload?.message;
      });
  },
});

export const { updateMacueDetails, updateCompleteMacue, updateMacueId } =
  macueSlice.actions;
export const macueSelector = (state) => state.macue;

export default macueSlice.reducer;
